import moment from 'moment'
import get from 'lodash/get'
import omit from 'lodash/omit'
import isEqual from 'lodash/isEqual'
import { checkUrlImage } from '~/utils/file'
import { UPDATE_USER_PROFILE } from '~/graphql/mutations/user'
import {
  GET_ALL_COURSES,
  GET_ACADEMY_COURSE_INFO,
  MY_COURSES,
  GET_INTERNAL_COURSES,
  GET_LIST_COURSE,
  GET_COURSE_AUDIT_LOG,
} from '~/graphql/queries/academyCourses'
import {
  ENROLL_TO_COURSE,
  UPDATE_COURSE,
  DUPLICATE_COURSE,
  CREATE_COURSE,
  REMOVE_COURSES,
  UNENROLL_COURSE,
  ENROLL_INTERNAL_COURSE,
  COURSE_UPDATE_POST_COURSE_QUESTIONS,
  COURSE_DELETE_POST_COURSE_QUESTIONS,
} from '~/graphql/mutations/course'
import { DEFAULT_LIMIT } from '~/utils/const'

const actionTypes = {
  ENROLL_TO_COURSE: 'ENROLL_TO_COURSE',
  UPDATE_COURSE: 'UPDATE_COURSE',
  DUPLICATE_COURSE: 'DUPLICATE_COURSE',
  CREATE_COURSE: 'CREATE_COURSE',
  REMOVE_COURSES: 'REMOVE_COURSES',
  GET_ACADEMY_COURSE_INFO: 'GET_ACADEMY_COURSE_INFO',
  GET_ALL_COURSES: 'GET_ALL_COURSES',
  UNENROLL_COURSE: 'UNENROLL_COURSE',
  MY_COURSES: 'MY_COURSES',
  GET_INTERNAL_COURSES: 'GET_INTERNAL_COURSES',
  GET_LIST_COURSE: 'GET_LIST_COURSE',
  ENROLL_INTERNAL_COURSE: 'ENROLL_INTERNAL_COURSE',
  GET_COURSE_AUDIT_LOG: 'GET_COURSE_AUDIT_LOG',
  TOGGLE_FAVORITE_COURSE: 'TOGGLE_FAVORITE_COURSE',
  COURSE_UPDATE_POST_COURSE_QUESTIONS: 'COURSE_UPDATE_POST_COURSE_QUESTIONS',
  COURSE_DELETE_POST_COURSE_QUESTIONS: 'COURSE_DELETE_POST_COURSE_QUESTIONS',
  GET_MY_ACTIVITY_COURSES: 'GET_MY_ACTIVITY_COURSES',
}

const mutationTypes = {
  SET_ENROLLING: 'SET_ENROLLING',
  SET_UPDATING: 'SET_UPDATING',
  SET_CREATING: 'SET_CREATING',
  SET_GETTING: 'SET_GETTING',
  SET_REMOVING: 'SET_REMOVING',
  SET_FETCHING_ALL_COURSES: 'SET_FETCHING_ALL_COURSES',
  SET_ALL_COURSES: 'SET_ALL_COURSES',
  SET_TOTAL_COURSES: 'SET_TOTAL_COURSES',
  SET_COURSE_PUBLISHED: 'SET_COURSE_PUBLISHED',
  SET_UNENROLLING: 'SET_UNENROLLING',
  SET_INTERNAL_COURSES_FILTER: 'SET_INTERNAL_COURSES_FILTER',
  SET_INTERNAL_COURSES: 'SET_INTERNAL_COURSES',
  SET_INTERNAL_COURSE_INFO: 'SET_INTERNAL_COURSE_INFO',
  ADD_INTERNAL_COURSE_AFTER_DUPLICATE: 'ADD_INTERNAL_COURSE_AFTER_DUPLICATE',
  SET_MY_ACTIVITY_COURSES: 'SET_MY_ACTIVITY_COURSES',
  SET_MY_ACTIVITY_COURSES_FILTER: 'SET_MY_ACTIVITY_COURSES_FILTER',
  CLEAR_MY_ACTIVITY_COURSES_FILTER: 'CLEAR_MY_ACTIVITY_COURSES_FILTER',
  SET_MY_ACTIVITY_COURSES_SORT: 'SET_MY_ACTIVITY_COURSES_SORT',
  CLEAR_MY_ACTIVITY_COURSES_SORT: 'CLEAR_MY_ACTIVITY_COURSES_SORT',
}

const defaultState = {
  enrolling: false,
  updating: false,
  creating: false,
  getting: false,
  removing: false,
  fetchingAll: true,
  allCourses: [],
  myActivityCourses: {
    data: [],
    filter: {
      search: null,
      activityStatus: null,
    },
    sort: {
      sortField: null,
      sortDirection: null,
    },
    loading: false,
  },
  internalCourse: {
    data: [],
    meta: {
      limit: DEFAULT_LIMIT,
      page: 1,
      total: 0,
    },
    filter: {
      search: null,
      limit: DEFAULT_LIMIT,
      page: 1,
    },
  },
  totalCourses: null,
  unEnrolling: false,
}
export const state = () => defaultState

export const mutations = {
  [mutationTypes.SET_ENROLLING](state, enrolling) {
    state.enrolling = enrolling
  },
  [mutationTypes.SET_UPDATING](state, updating) {
    state.updating = updating
  },
  [mutationTypes.SET_CREATING](state, creating) {
    state.creating = creating
  },
  [mutationTypes.SET_GETTING](state, getting) {
    state.getting = getting
  },
  [mutationTypes.SET_REMOVING](state, removing) {
    state.removing = removing
  },
  [mutationTypes.SET_UNENROLLING](state, unEnrolling) {
    state.unEnrolling = unEnrolling
  },
  [mutationTypes.SET_ALL_COURSES](state, allCourses) {
    state.allCourses = allCourses
  },
  [mutationTypes.SET_FETCHING_ALL_COURSES](state, fetchingAll) {
    state.fetchingAll = fetchingAll
  },
  [mutationTypes.SET_TOTAL_COURSES](state, totalCourses) {
    state.totalCourses = totalCourses
  },
  [mutationTypes.SET_INTERNAL_COURSES](state, response) {
    state.internalCourse.data = response.data
    state.internalCourse.meta = response.meta
  },
  [mutationTypes.SET_INTERNAL_COURSE_INFO](state, payload) {
    const { id, updateData } = payload
    const foundIndex = state.internalCourse.data.findIndex((course) => course.id === id)
    if (foundIndex > -1 && updateData) {
      updateData.forEach((data) => {
        state.internalCourse.data[foundIndex][data.field] = data.value
        state.internalCourse.data[foundIndex].updatedAt = moment.utc().format('YYYY-MM-DDTHH:mm:ss')
      })
    }
  },
  [mutationTypes.ADD_INTERNAL_COURSE_AFTER_DUPLICATE](state, payload) {
    if (payload) {
      state.internalCourse.data.unshift(payload)
      state.internalCourse.meta.total += 1
    }
  },
  [mutationTypes.SET_INTERNAL_COURSES_FILTER](state, filter) {
    state.internalCourse.filter = { ...state.internalCourse.filter, ...filter }
  },
  [mutationTypes.SET_COURSE_PUBLISHED](state, info) {
    const foundedCourse = state.allCourses.find((course) => course.id === info.id)
    if (foundedCourse) {
      foundedCourse.published = info.val
      foundedCourse.publishedAt = info.val ? moment().format('YYYY-MM-DDTHH:mm:ss') : null
    }
  },
  [mutationTypes.SET_MY_ACTIVITY_COURSES](state, payload) {
    state.myActivityCourses.data = payload.data
  },
  [mutationTypes.SET_MY_ACTIVITY_COURSES_FILTER](state, payload) {
    state.myActivityCourses.filter = {
      ...state.myActivityCourses.filter,
      ...payload,
    }
  },
  [mutationTypes.CLEAR_MY_ACTIVITY_COURSES_FILTER](state) {
    state.myActivityCourses.filter = {
      search: '',
      status: '',
    }
  },
  [mutationTypes.SET_MY_ACTIVITY_COURSES_SORT](state, payload) {
    state.myActivityCourses.sort = {
      ...state.myActivityCourses.sort,
      ...payload,
    }
  },
}

export const actions = {
  async [actionTypes.COURSE_UPDATE_POST_COURSE_QUESTIONS]({ commit }, variables) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_UPDATE_POST_COURSE_QUESTIONS,
        variables,
      })
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.COURSE_DELETE_POST_COURSE_QUESTIONS]({ commit }, variables) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: COURSE_DELETE_POST_COURSE_QUESTIONS,
        variables,
      })
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.GET_INTERNAL_COURSES]({ commit, rootState, getters }, { filter, isReset = false }) {
    try {
      if (!isReset && isEqual(getters.internalCourseFilter, filter)) {
        return {
          data: getters.internalCourse,
          success: true,
        }
      }

      const apolloClient = this.app.apolloProvider.defaultClient
      const schoolId = rootState.school.schoolProfile.id
      const { data } = await apolloClient.query({
        query: GET_INTERNAL_COURSES,
        variables: { ...filter, schoolId, isLatest: true },
        fetchPolicy: 'no-cache',
      })

      commit('SET_INTERNAL_COURSES_FILTER', filter)
      commit(
        mutationTypes.SET_INTERNAL_COURSES,
        isReset
          ? data.academyCourses
          : { ...data.academyCourses, data: [...get(getters, 'internalCourse.data', []), ...data.academyCourses.data] }
      )

      return {
        data: data.academyCourses,
        success: true,
      }
    } catch (error) {
      console.error('GET_INTERNAL_COURSES', error)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.GET_LIST_COURSE]({ state, commit, rootState }, filter) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const schoolId = rootState.school.schoolProfile.id
      const { data } = await apolloClient.query({
        query: GET_LIST_COURSE,
        variables: { ...filter, schoolId, isLatest: true, noUpdatedDraft: true },
        fetchPolicy: 'no-cache',
      })

      return {
        data: data.academyCourses,
        success: true,
      }
    } catch (error) {
      console.error('GET_LIST_COURSE', error)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.ENROLL_TO_COURSE]({ commit }, params) {
    commit(mutationTypes.SET_ENROLLING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: ENROLL_TO_COURSE,
        variables: {
          ...params,
        },
      })
      commit(mutationTypes.SET_ENROLLING, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.UNENROLL_COURSE]({ commit }, courseId) {
    commit(mutationTypes.SET_UNENROLLING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: UNENROLL_COURSE,
        variables: {
          courseId,
        },
      })
      commit(mutationTypes.SET_UNENROLLING, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.UPDATE_COURSE]({ commit, getters }, params) {
    commit(mutationTypes.SET_UPDATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: UPDATE_COURSE,
        variables: {
          ...omit(params, ['courseType']),
        },
      })
      if (params.courseType && data && data.academyUpdateCourse) {
        if (get(params, 'course.status', '') === 'ARCHIVED') {
          const { data, meta } = getters.internalCourse
          commit(mutationTypes.SET_INTERNAL_COURSES, {
            data: data.filter((course) => course.id !== params.courseId),
            meta,
          })
        } else {
          commit(mutationTypes[`SET_${params.courseType}_COURSE_INFO`], {
            id: params.courseId,
            updateData: Object.keys(params.course).map((key) => ({ field: key, value: params.course[key] })),
          })
        }
      }
      return {
        data,
        success: true,
      }
    } catch (error) {
      console.error('UPDATE_COURSE', error)
      return {
        error,
        success: false,
      }
    } finally {
      commit(mutationTypes.SET_UPDATING, false)
    }
  },
  async [actionTypes.DUPLICATE_COURSE]({ commit }, params) {
    commit(mutationTypes.SET_UPDATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: DUPLICATE_COURSE,
        variables: {
          ...omit(params, ['courseType']),
        },
      })
      if (params.courseType && data && data.academyDuplicateCourse) {
        // commit(mutationTypes[`ADD_${params.courseType}_COURSE_AFTER_DUPLICATE`], data.academyDuplicateCourse)
      }
      commit(mutationTypes.SET_UPDATING, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.REMOVE_COURSES]({ commit }, courseIds) {
    commit(mutationTypes.SET_REMOVING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: REMOVE_COURSES,
        variables: {
          courseIds,
        },
      })
      commit(mutationTypes.SET_REMOVING, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.CREATE_COURSE]({ commit }, course) {
    commit(mutationTypes.SET_CREATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: CREATE_COURSE,
        variables: course,
      })
      commit(mutationTypes.SET_CREATING, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      commit(mutationTypes.SET_CREATING, false)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.GET_ACADEMY_COURSE_INFO]({ commit }, slug) {
    commit(mutationTypes.SET_GETTING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        fetchPolicy: 'no-cache',
        query: GET_ACADEMY_COURSE_INFO,
        variables: {
          slug,
        },
      })
      commit(mutationTypes.SET_GETTING, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.GET_ALL_COURSES]({ commit, rootState }, { params, limit = 10, haveActivities = false }) {
    commit(mutationTypes.SET_FETCHING_ALL_COURSES, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const schoolId = rootState.school.schoolProfile.id
      const queries = params
        ? {
            ...params,
            schoolId,
          }
        : {
            schoolId,
            limit,
            haveActivities,
          }
      const { data } = await apolloClient.query({
        query: GET_ALL_COURSES,
        fetchPolicy: 'no-cache',
        variables: {
          ...queries,
        },
      })
      for (let index = 0; index < data.academySchoolCourses.data.length; index++) {
        const course = data.academySchoolCourses.data[index]
        if (course.cover) {
          try {
            await checkUrlImage(course.cover)
          } catch (error) {
            course.cover = 'https://trirama.com/wp-content/uploads/2016/10/orionthemes-placeholder-image.png'
          }
        }
      }
      commit(mutationTypes.SET_ALL_COURSES, data.academySchoolCourses.data)
      commit(mutationTypes.SET_TOTAL_COURSES, data.academySchoolCourses.meta.total)
      commit(mutationTypes.SET_FETCHING_ALL_COURSES, false)
      return {
        data,
        success: true,
      }
    } catch (error) {
      console.error('GET_ALL_COURSES', error)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.MY_COURSES]({ commit }, variables) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: MY_COURSES,
        variables,
        fetchPolicy: 'no-cache',
      })
      return data.academyMyCourseEnroll
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.GET_COURSE_AUDIT_LOG]({ commit }, variables) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.query({
        query: GET_COURSE_AUDIT_LOG,
        variables,
        fetchPolicy: 'no-cache',
      })
      return data
    } catch (error) {
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.ENROLL_INTERNAL_COURSE]({ commit }, variables) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: ENROLL_INTERNAL_COURSE,
        variables,
      })
      return {
        success: true,
        data,
      }
    } catch (error) {
      console.error(error)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.TOGGLE_FAVORITE_COURSE]({ rootState, commit }, id) {
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const userCourseIds = rootState.profile.userProfile.courses.map((course) => course.id)
      const index = userCourseIds.indexOf(id)
      let isAdding = true
      if (index > -1) {
        userCourseIds.splice(index, 1)
        isAdding = false
      } else {
        userCourseIds.push(id)
      }
      const { data } = await apolloClient.mutate({
        mutation: UPDATE_USER_PROFILE,
        variables: {
          profile: {
            courseIds: userCourseIds,
          },
          schoolId: rootState.school.schoolProfile.id,
        },
      })
      if (data.academyStaffUpdateProfile) {
        commit('profile/UPDATE_FAVORITE_COURSE', data.academyStaffUpdateProfile.courses, { root: true })
      }
      return {
        success: true,
        data: isAdding,
      }
    } catch (error) {
      console.error(error)
      return {
        error,
        success: false,
      }
    }
  },
  async [actionTypes.GET_MY_ACTIVITY_COURSES]({ dispatch, commit, getters }, params) {
    try {
      const data = await dispatch(actionTypes.MY_COURSES, {
        ...params,
        forMyActivityPage: true,
      })
      if (data) {
        if (params.isLoadMore) {
          commit(mutationTypes.SET_MY_ACTIVITY_COURSES, {
            data: [...getters.myActivityCourses.data, ...data.data],
          })
        } else {
          commit(mutationTypes.SET_MY_ACTIVITY_COURSES, data)
        }
      }
      return {
        success: true,
        data,
      }
    } catch (error) {
      console.error(error)
      return {
        error,
        success: false,
      }
    }
  },
}

export const getters = {
  enrolling: (state) => state.enrolling,
  updating: (state) => state.updating,
  creating: (state) => state.creating,
  getting: (state) => state.getting,
  fetchingAll: (state) => state.fetchingAll,
  allCourses: (state) => state.allCourses,
  totalCourses: (state) => state.totalCourses,
  unenrolling: (state) => state.unenrolling,
  internalCourse: (state) => state.internalCourse,
  internalCourseFilter: (state) => state.internalCourse.filter,
  myActivityCourses: (state) => state.myActivityCourses,
}
